import React, {Component} from 'react';
import './PCBVideo.css';
import '../../../Common/Common.css';
import Video from '../../../../assets/video/home-video.mp4';
import {FormattedMessage} from "react-intl";
import imgDiv1 from '../../../../assets/img/img-1.png';
import imgDiv2 from '../../../../assets/img/img-2.png';
import imgDiv3 from '../../../../assets/img/img-3.png';
import imgDiv4 from '../../../../assets/img/img-4.png';
import imgDiv5 from '../../../../assets/img/img-5.png';
import imgDiv6 from '../../../../assets/img/img-6.png';
import imgDiv7 from '../../../../assets/img/img-7.png';
import imgDiv8 from '../../../../assets/img/img-8.png';
import imgDiv9 from '../../../../assets/img/img-9.png';
import imgDash from '../../../../assets/img/dash.png';

// import imgDash from '../../../../assets/img/dash.png';

class PCBVideo extends Component {
    render() {
        return (
            <div className="kit-cut-screen-cast">
                <div className="homepage-video-heading">
                    <FormattedMessage id="app.home-content.pcb-video.heading"
                                      defaultMessage="Application is completed on the net!"
                                      description=""/>

                </div>
                <br/>
                <div className="pcb-video-caption">
                    <FormattedMessage id="app.home-content.pcb-video.caption"
                                      defaultMessage="You can sign up 24 hours a day, 365 days a year. It is a flow from the application on the website to the conclusion of the contract."
                                      description=""/>
                </div>
                <br/>
                <div>
                    <table className="img-row-tbl">
                        <tbody>
                        <tr className="img-row-tbl-tr">
                            <td><img src={imgDiv1} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv2} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv3} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv4} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv5} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv6} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv7} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv8} alt="imgReg" className="video-slider-upper-bar1"/></td>
                            <td><img src={imgDash} className="img-dash"/></td>
                            <td><img src={imgDiv9} alt="imgReg" className="video-slider-upper-bar1"/></td>
                        </tr>
                        <tr className="img-row-tbl-tr" id="test-demo">
                            <td><span className="img-vdo-slider-caption"><b>会員登録</b></span></td>
                            <td>&nbsp;</td>
                            <td> <span className="img-vdo-slider-caption"><b>オンライン見積り</b></span></td>
                            <td>&nbsp;</td>
                            <td> <span className="img-vdo-slider-caption"><b>ガーバーファイル</b><br/><b>アップロード</b></span></td>
                            <td>&nbsp;</td>
                            <td>  <span className="img-vdo-slider-caption"><b>ガーバーファイル</b><br/><b>チェック</b></span></td>
                            <td>&nbsp;</td>
                            <td> <span className="img-vdo-slider-caption"><b>注文確認</b></span></td>
                            <td>&nbsp;</td>
                            <td><span className="img-vdo-slider-caption"><b>支払い</b></span></td>
                            <td>&nbsp;</td>
                            <td><span className="img-vdo-slider-caption"><b>生産</b></span></td>
                            <td>&nbsp;</td>
                            <td><span className="img-vdo-slider-caption"><b>香港出荷</b></span></td>
                            <td>&nbsp;</td>
                            <td><span className="img-vdo-slider-caption"><b>配達</b></span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <br/>
                <div className="video-content">
                    <video className="pcb-video" controls loop muted>
                        <source src={Video} type="video/mp4"/>
                    </video>
                </div>
            </div>
        );
    }
}

export default PCBVideo;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/PCBVideo/PCBVideo.js